export default function() {
  if (document.querySelector('.cf-turnstile') && window.turnstile) {
    window.turnstile.render(".cf-turnstile")
  }
}
